export default "__VITE_ASSET__BCe2x5GgrP0K$8pEzuQGZg__"